import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import EditableTable from "components/Table/EditableTable";
import accountService from "services/account-service";
import ConfirmationModal from "modals/miscellaneous/ConfirmationModal";

export default function UserTable({
  data,
  setSelectedData,
  loadingState,
  updateTableFunction,
}) {
  const [selectedUser, setSelectedUser] = useState();
  const [rowToDelete, setRowToDelete] = useState();
  const [open, setOpen] = useState(false);
  const [promptResponse, setPromptResponse] = useState(null);
  const [submit, setSubmit] = useState(false);
  const [submitKind, setSubmitKind] = useState("");
  const [promptDesc, setPromptDesc] = useState("");

  const [loading, setLoading] = useState(false);

  setSelectedData(selectedUser);

  useEffect(() => {
    if (rowToDelete) {
      setPromptDesc("Are you sure you want to delete this data?");
      setSubmitKind("delete");
      setOpen(true);
    }
  }, [rowToDelete]);

  useEffect(() => {
    if (!open && submit && promptResponse) {
      accountService
        .deleteUser(rowToDelete ? rowToDelete[0]?.uid : "")
        .then(() => {
          setRowToDelete(null);
          setSubmit(false);
          updateTableFunction();
        })
        .catch((err) => {
          alert(err?.message);
          setRowToDelete(null);
          setSubmit(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [submit, promptResponse]);

  const columns = [
    // { field: "uid", headerName: "ID", width: 70 },
    {
      field: "username",
      headerName: "User",
      width: 200,
    },
    {
      field: "role",
      headerName: "Role",
      width: 200,
    },
    {
      field: "officeName",
      headerName: "Office",
      width: 500,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <ConfirmationModal
        open={open}
        handleClose={() => setOpen(false)}
        setPromptResponse={setPromptResponse}
        setSubmit={setSubmit}
        submitKind={submitKind}
        promptDesc={promptDesc}
      />
      <EditableTable
        data={data}
        columns={columns}
        checkbox
        loading={loadingState || loading}
        singleSelect
        selectedData={setSelectedUser}
        rowToDelete={setRowToDelete}
        height="60vh"
        remove
      />
    </Box>
  );
}
